module.exports = __webpack_public_path__ + "media/images/atterra-2-29dc113a16c3add7134d73c84a203ef6.jpg";